import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISchool, ISchools } from '../interfaces/school';

@Injectable({
  providedIn: 'root',
})
export class SchoolService {
  constructor(private httpClient: HttpClient) {}

  getSchools(url: string): Observable<ISchools> {
    return this.httpClient.get<ISchools>(url, { headers: { accept: '*/*' } }) as Observable<ISchools>;
  }

  getSchoolById(url: string): Observable<ISchool> {
    return this.httpClient.get<ISchool>(url, { headers: { accept: '*/*' } }) as Observable<ISchool>;
  }

  updateSchoolBrand(url: string, schoolForm: any): Observable<ISchool> {
    return this.httpClient.patch<ISchool>(url, schoolForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISchool>;
  }

  createSchool(url: string, schoolForm: any): Observable<ISchool> {
    return this.httpClient.post<ISchool>(url, schoolForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISchool>;
  }
}
